// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"8325c079","455":"77c6d25a"}[chunkId] + ".chunk.js";
};